export const FloatingPopupPlaceholderImage = ({ ...other }) => (
  <svg
    fill="none"
    height="518"
    viewBox="0 0 796 518"
    width="796"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <rect
      fill="currentColor"
      height="12.706"
      opacity="0.78"
      rx="6.353"
      width="358.702"
      x="406.645"
      y="152.109"
    />
    <rect
      fill="currentColor"
      height="12.706"
      opacity="0.78"
      rx="6.353"
      width="376.941"
      x="406.645"
      y="181.758"
    />
    <rect
      fill="currentColor"
      height="12.706"
      opacity="0.78"
      rx="6.353"
      width="207.529"
      x="406.645"
      y="211.406"
    />
    <rect
      fill="currentColor"
      height="12.706"
      opacity="0.78"
      rx="6.353"
      width="358.702"
      y="333.414"
    />
    <rect
      fill="currentColor"
      height="12.706"
      opacity="0.78"
      rx="6.353"
      width="376.941"
      y="363.062"
    />
    <rect
      fill="currentColor"
      height="12.706"
      opacity="0.78"
      rx="6.353"
      width="109.435"
      y="392.711"
    />
    <path
      d="M0 127.203h374v148H0zM407 295h389v149H407zM0 .203h796v110H0zM0 460.203h796v59H0z"
      fill="currentColor"
    />
  </svg>
);

export const ElementPopupPlaceholderImage = ({ ...other }) => (
  <svg
    fill="none"
    height="518"
    viewBox="0 0 748 518"
    width="748"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <rect
      fill="currentColor"
      height="14.463"
      opacity="0.78"
      rx="7.231"
      width="311.667"
      x="363"
      y="142.688"
    />
    <rect
      fill="currentColor"
      height="14.463"
      opacity="0.78"
      rx="7.231"
      width="326.333"
      x="363"
      y="171.617"
    />
    <rect
      fill="currentColor"
      height="14.463"
      opacity="0.78"
      rx="7.231"
      width="311.667"
      x="363"
      y="298.141"
    />
    <rect
      fill="currentColor"
      height="14.463"
      opacity="0.78"
      rx="7.231"
      width="326.333"
      x="363"
      y="327.07"
    />
    <rect
      fill="currentColor"
      height="14.463"
      opacity="0.78"
      rx="7.231"
      width="95.333"
      x="363"
      y="356"
    />
    <path
      d="M0 119h322.667v124.667H0zM0 0h748v104H0zM748 522.336H0V419.669h748zM0 258.328h322.667v150.333H0z"
      fill="currentColor"
    />
  </svg>
);
